const isScriptNode = (node: HTMLElement) => node.tagName === "SCRIPT"

const isExternalScript = (node: HTMLElement) =>
    !!(node as HTMLScriptElement).src && (node as HTMLScriptElement).src !== ""

const cloneScriptNode = (node: HTMLElement) => {
    const script = document.createElement("script")
    script.text = node.innerHTML
    for (let i = node.attributes.length - 1; i >= 0; i--) {
        script.setAttribute(node.attributes[i].name, node.attributes[i].value)
    }
    return script
}

export const replaceScriptNode = (
    node: HTMLElement | null,
    includeExternalScripts = false
) => {
    if (node) {
        if (
            isScriptNode(node) &&
            (includeExternalScripts || !isExternalScript(node as HTMLScriptElement))
        ) {
            if (node.parentNode) {
                node.parentNode.replaceChild(cloneScriptNode(node), node)
            }
        } else {
            let i = 0
            const children = node.childNodes
            while (i < children.length) {
                replaceScriptNode(
                    children[(i += 1)] as HTMLElement,
                    includeExternalScripts
                )
            }
        }
    }
    return node
}

export const refreshCheckout = async <T>(promise: Promise<T>): Promise<T> => {
    if (!window.CentraCheckout) {
        return promise
    }

    window.CentraCheckout.suspend()
    const result = await promise
    window.CentraCheckout.resume()
    return result
}
